// KYC API Service
// This file contains placeholder functions for KYC API calls
// Replace these with actual API endpoints when provided

import stbServer from "../utils/axios";
import { API_ENDPOINTS } from "../api";

// Placeholder functions - to be replaced with actual API endpoints
export const kycApi = {
  // Get countries list
  getCountries: async () => {
    return await stbServer.get('/b2b/kyc/buckzy/countries/');
  },

  // Get organization types
  getOrganizationTypes: async () => {
    return await stbServer.get('/b2b/kyc/buckzy/organization_types/');
  },

  // Get line of business
  getLineOfBusiness: async () => {
    return await stbServer.get('/b2b/kyc/buckzy/line_of_business/');
  },

  // Get document types
  getDocumentTypes: async () => {
    return await stbServer.get('/b2b/kyc/document_type/');
  },

  // Get states by country ID
  getStates: async (countryId) => {
    return await stbServer.get(`/b2b/kyc/buckzy/states/?country_id=${countryId}`);
  },

  // Get cities by country ID and state ID
  getCities: async (countryId, stateId) => {
    return await stbServer.get(`/b2b/kyc/buckzy/cities/?country_id=${countryId}&state_id=${stateId}`);
  },

  // Get business document types
  getBusinessDocTypes: async () => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.getBusinessDocTypes
    // return await stbServer.get(API_ENDPOINTS.getBusinessDocTypes);
    return { data: { data: [] } }; // Placeholder
  },

  // Get business documents
  getBusinessDocs: async () => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.getBusinessDocs
    // return await stbServer.get(API_ENDPOINTS.getBusinessDocs);
    return { data: { data: { documents: [] } } }; // Placeholder
  },

  // Get personal documents
  getPersonalDocuments: async () => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.getPersonalDocuments
    // return await stbServer.get(API_ENDPOINTS.getPersonalDocuments);
    return { data: { data: { documents: [] } } }; // Placeholder
  },

  // Get shareholders list
  getShareholdersList: async () => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.getShareholdersList
    // return await stbServer.get(API_ENDPOINTS.getShareholdersList);
    return { data: { data: [] } }; // Placeholder
  },

  // Get party data
  getPartyData: async () => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.getPartyData
    // return await stbServer.get(API_ENDPOINTS.getPartyData);
    return { data: { data: null } }; // Placeholder
  },

  // Save party data
  savePartyData: async (payload) => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.savePartyData
    // return await stbServer.post(API_ENDPOINTS.savePartyData, payload);
    return { data: { success: true } }; // Placeholder
  },

  // Get documents by unique_key
  getDocuments: async (uniqueKey) => {
    return await stbServer.get(`/b2b/kyc/documents/?unique_key=${uniqueKey}`);
  },

  // Add document
  addDocument: async (payload) => {
    return await stbServer.post('/b2b/kyc/documents/', payload);
  },

  // Update document
  updateDocument: async (payload) => {
    return await stbServer.patch('/b2b/kyc/documents/', payload);
  },

  // Upload file to /file endpoint first
  uploadFile: async (fileData) => {
    const additionalHeader = {
      "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
    };
    const response = await stbServer.post('/file/', fileData, {
      headers: {
        ...stbServer.defaults.headers,
        ...additionalHeader,
      },
    });
    return response?.data?.data; // Returns { file_id, url, ... }
  },

  // Upload document (now uses file_id from /file endpoint)
  uploadDocument: async (payload) => {
    return await stbServer.post('/b2b/kyc/buckzy/documents/', payload);
  },

  // Delete document
  deleteDocument: async (uniqueKey, documentId) => {
    return await stbServer.delete('/b2b/kyc/documents/', {
      data: {
        unique_key: uniqueKey,
        document_id: documentId
      }
    });
  },

  // Preview document
  previewDocument: async (documentId) => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.previewDocument
    // return await stbServer.get(`${API_ENDPOINTS.previewDocument}/${documentId}/view/`);
    return { data: { data: {} } }; // Placeholder
  },

  // Check unique key
  checkUniqueKey: async (uniqueKey) => {
    return await stbServer.post('/b2b/kyc/check_unique_key/', {
      unique_key: uniqueKey
    });
  },

  // Get KYC data
  getKycData: async (uniqueKey) => {
    return await stbServer.get(`/b2b/kyc/kyc_process/?unique_key=${uniqueKey}`);
  },

  // Submit or update KYC data (Step 1 - Business Details)
  submitKycBusinessData: async (payload) => {
    return await stbServer.patch('/b2b/kyc/kyc_process/', payload);
  },

  // Submit KYC (Final submission - Step 3)
  submitKyc: async (payload) => {
    return await stbServer.post('/b2b/kyc/kyc_process/', payload);
  },

  // Complete KYC (Final submission - Step 3)
  completeKyc: async (uniqueKey) => {
    return await stbServer.post('/b2b/kyc/complete/', {
      unique_key: uniqueKey
    });
  },

  // Get business info (for status)
  getBusinessInfo: async () => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.getBusinessInfo
    // return await stbServer.get(API_ENDPOINTS.getBusinessInfo);
    return { data: { data: { kyc_status: { value: "not_done" }, kyb_status: { value: "not_done" } } } }; // Placeholder
  },

  // Get KYB status history
  getKybStatusHistory: async (id) => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.getKybStatusHistory
    // return await stbServer.get(`${API_ENDPOINTS.getKybStatusHistory}${id}/history/`);
    return { data: { data: { history: [] } } }; // Placeholder
  },

  // Get KYC status history
  getKycStatusHistory: async (id) => {
    // TODO: Replace with actual endpoint from API_ENDPOINTS.getKycStatusHistory
    // return await stbServer.get(`${API_ENDPOINTS.getKycStatusHistory}${id}/history/`);
    return { data: { data: { history: [] } } }; // Placeholder
  },
};

